import { useQuery } from '@tanstack/react-query'

import { listAccounts } from '../integrationsApi'
import { integrationsKeys } from '../queryKeys/integrationsKeys'

const useListAccountsQuery = (
  accountId: string,
  isEnabled = true,
  provider?: string
) => {
  const getIntegrationsQuery = useQuery({
    queryKey: integrationsKeys.accounts(accountId, provider),
    queryFn: () => listAccounts({ accountId, provider }),
    enabled: isEnabled,
  })
  return getIntegrationsQuery
}

export default useListAccountsQuery
